import i18n from "../../../i18n";

export const ManageOperations = i18n.t('IncidentDetails.ManageOperations');
export const ChooseFiles = i18n.t('IncidentDetails.ChooseFiles');
export const UploadFiles = i18n.t('IncidentDetails.UploadFiles');
export const Upload = i18n.t('IncidentDetails.Upload');
export const Cancel = i18n.t('IncidentDetails.Cancel');
export const Addfiles = i18n.t('IncidentDetails.Addfiles');
export const edit = i18n.t('IncidentDetails.edit');
export const Clearfile = i18n.t('IncidentDetails.Clearfile');
export const ChangeStatus = i18n.t('IncidentDetails.ChangeStatus');
export const Update = i18n.t('IncidentDetails.Update');
export const Resolve = i18n.t('IncidentDetails.Resolve');
export const New = i18n.t('IncidentDetails.New');
export const Inprogress = i18n.t('IncidentDetails.Inprogress');
export const OnHold = i18n.t('IncidentDetails.OnHold');
export const Resolved = i18n.t('IncidentDetails.Resolved');
export const Closed = i18n.t('IncidentDetails.Closed');
export const Canceled = i18n.t('IncidentDetails.Canceled');
export const Contacttype = i18n.t('IncidentDetails.Contacttype');
export const AssignedTo = i18n.t('IncidentDetails.AssignedTo');
export const AssignmentGroup = i18n.t('IncidentDetails.AssignmentGroup');
export const franchise = i18n.t('IncidentDetails.franchise');
export const Category = i18n.t('IncidentDetails.Category');
export const SubCategory = i18n.t('IncidentDetails.SubCategory');
export const BusinessService = i18n.t('IncidentDetails.BusinessService');
export const Impact = i18n.t('IncidentDetails.Impact');
export const Urgency = i18n.t('IncidentDetails.Urgency');
export const Priority = i18n.t('IncidentDetails.Priority');
export const ConfigurationItem = i18n.t('IncidentDetails.ConfigurationItem');
export const Description = i18n.t('IncidentDetails.Description');
export const Apphost = i18n.t('IncidentDetails.Apphost');
export const Client = i18n.t('IncidentDetails.Client');
export const Technology = i18n.t('IncidentDetails.Technology');
export const Jobid = i18n.t('IncidentDetails.Jobid');
export const SessionNo = i18n.t('IncidentDetails.SessionNo');
export const ProcessId = i18n.t('IncidentDetails.ProcessId');
export const CreationTime = i18n.t('IncidentDetails.CreationTime');
export const StartTime = i18n.t('IncidentDetails.StartTime');
export const EndTime = i18n.t('IncidentDetails.EndTime');
export const UpdatedTime = i18n.t('IncidentDetails.UpdatedTime');
export const ProcessName = i18n.t('IncidentDetails.ProcessName');
export const Resource = i18n.t('IncidentDetails.Resource');
export const Resolutionmode = i18n.t('IncidentDetails.Resolutionmode');
export const ExceptionClass = i18n.t('IncidentDetails.ExceptionClass');
export const Maxfile = i18n.t('IncidentDetails.Maxfile');
export const Caller = i18n.t('IncidentDetails.Caller');
export const ShortDescription = i18n.t('IncidentDetails.ShortDescription');
export const ProbableRootCause = i18n.t('IncidentDetails.ProbableRootCause');
export const TicketType = i18n.t('IncidentDetails.TicketType');
export const Action = i18n.t('IncidentDetails.Action');
export const RemediationType = i18n.t('IncidentDetails.RemediationType');
export const RootcauseAnalysis = i18n.t('IncidentDetails.RootcauseAnalysis');
export const Confidence = i18n.t('IncidentDetails.Confidence');
export const ManagedEntityName = i18n.t('IncidentDetails.ManagedEntityName');
export const Assistance = i18n.t('IncidentDetails.Assistance');
export const Remediation = i18n.t('IncidentDetails.Remediation');
export const Notes = i18n.t('IncidentDetails.Notes');
export const Resolution = i18n.t('IncidentDetails.Resolution');
export const Execute = i18n.t('IncidentDetails.Execute');
export const ShowMore = i18n.t('IncidentDetails.ShowMore');
export const ShowLess = i18n.t('IncidentDetails.ShowLess');
export const ApproveAndUpdateTicket = i18n.t('IncidentDetails.ApproveAndUpdateTicket');
export const NoDataAvailable = i18n.t('IncidentDetails.NoDataAvailable');
export const OpenInTicketingTool = i18n.t('IncidentDetails.OpenInTicketingTool');
export const Home = i18n.t('IncidentDetails.Home');
export const Collaboration = i18n.t('IncidentDetails.Collaboration');
export const SubmitFeedback = i18n.t('IncidentDetails.SubmitFeedback');
export const AcceptSuggestion = i18n.t('IncidentDetails.AcceptSuggestion');
export const RejectSuggestion = i18n.t('IncidentDetails.RejectSuggestion');
export const Feedback = i18n.t('IncidentDetails.Feedback');
export const RemediationSteps = i18n.t('IncidentDetails.RemediationSteps');
export const Answer = i18n.t('IncidentDetails.Answer');
export const Back = i18n.t('IncidentDetails.Back');
export const Done = i18n.t('IncidentDetails.Done');
export const AcceptedSuggestionFor = i18n.t('IncidentDetails.AcceptedSuggestionFor');
export const TypeRejectionFeedback = i18n.t('IncidentDetails.TypeRejectionFeedback');
export const ToSubmitSuggestion = i18n.t('IncidentDetails.ToSubmitSuggestion');
export const ToSubmitFeedback = i18n.t('IncidentDetails.ToSubmitFeedback');
export const PressUpdateInTopBar = i18n.t('IncidentDetails.PressUpdateInTopBar');
export const RefreshToViewSuggestion = i18n.t('IncidentDetails.RefreshToViewSuggestion');
export const postToCollaborationToolQuestion = i18n.t('IncidentDetails.postToCollaborationToolQuestion');
export const EnterYourComment = i18n.t('IncidentDetails.EnterYourComment');
export const SelectAssignedto = i18n.t('IncidentDetails.SelectAssignedto');
export const SelectAssignmentgroup = i18n.t('IncidentDetails.SelectAssignmentgroup');
export const ValueCannotBeUpdated = i18n.t('IncidentDetails.ValueCannotBeUpdated');
export const value = i18n.t('IncidentDetails.value');
export const UpdateIncident = i18n.t('IncidentDetails.UpdateIncident');
export const loading = i18n.t('IncidentDetails.loading');

export const incidentStatusItems = ['New', 'In Progress', 'On Hold', 'Resolved', 'Closed', 'Canceled'];

export const contactTypeItems = ['Email', 'Phone', 'Self-service', 'Walk-in'];

export const impactUrgencyItems = ['1-High', '2-Medium', '3-Low']
export const ResolvedBySOC = i18n.t('IncidentDetails.ResolvedBySOC');
export const ActionTakenBySOC = i18n.t('IncidentDetails.ActionTakenBySOC');
export const ReasonsToUpgrade = i18n.t('IncidentDetails.ReasonsToUpgrade');
export const ReasonsToDowngrade = i18n.t('IncidentDetails.ReasonsToDowngrade');
export const ReasonsForDowngradeNeeded = i18n.t('IncidentDetails.ReasonsForDowngradeNeeded');
export const ReasonsForUpgradeNeeded = i18n.t('IncidentDetails.ReasonsForUpgradeNeeded');
export const ChooseReasons = i18n.t('IncidentDetails.ChooseReasons');
export const PleaseProvideReason = i18n.t('IncidentDetails.PleaseProvideReason');
export const QueueName = i18n.t('analytics.QueueName');